export default {
  name: "StarExplosion",
  props: {
    autoLoop: {
      type: Boolean,
      default: false
    },
    starCount: {
      type: Number,
      default: 20
    },
    imageSrc: {
      type: String,
      required: true
    },
    sizeRange: {
      type: Array,
      default: () => [6, 14]
    },
    speedRange: {
      type: Array,
      default: () => [2, 5]
    }
  },
  data() {
    return {
      starImg: null,
      aspectRatio: 1,
      stars: [],
      canvasCtx: null,
      animationId: null
    };
  },
  mounted() {
    this.starImg = new Image();
    this.starImg.src = this.imageSrc;
    this.starImg.onload = () => {
      if (this.starImg.width && this.starImg.height) {
        this.aspectRatio = this.starImg.width / this.starImg.height;
      }
      const canvas = this.$refs.canvas;
      if (canvas) {
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
        this.canvasCtx = canvas.getContext("2d");
        if (this.autoLoop) {
          this.start();
        }
      }
    };
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    start() {
      this.stop();
      this.loop();
    },
    stop() {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    },
    loop() {
      const canvas = this.$refs.canvas;
      const ctx = this.canvasCtx;
      if (!canvas || !ctx || !this.starImg.complete) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.stars.forEach(s => {
        s.x += s.vx;
        s.y += s.vy;
        s.alpha -= s.decay;
      });
      this.stars = this.stars.filter(s => s.alpha > 0);
      this.stars.forEach(s => {
        ctx.globalAlpha = s.alpha;
        const height = s.radius;
        const width = height * this.aspectRatio;
        ctx.drawImage(this.starImg, s.x, s.y, width, height);
      });
      ctx.globalAlpha = 1;
      if (this.stars.length === 0 || this.stars.every(s => s.alpha < 0.1)) {
        this.generateExplosion();
      }
      this.animationId = requestAnimationFrame(this.loop);
    },
    generateExplosion() {
      const canvas = this.$refs.canvas;
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2 - 50;
      const [minSize, maxSize] = this.sizeRange;
      const [minSpeed, maxSpeed] = this.speedRange;
      this.stars = Array.from({
        length: this.starCount
      }, () => {
        // ➤ 仅向左或向右发射
        const leftOrRight = Math.random() < 0.5 ? 'left' : 'right';
        const baseAngle = leftOrRight === 'left' ? Math.PI : 0;
        const spread = Math.PI / 6; // ±30°
        const angle = baseAngle + (Math.random() - 0.5) * 2 * spread;
        const speed = Math.random() * (maxSpeed - minSpeed) + minSpeed;
        return {
          x: centerX,
          y: centerY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          radius: Math.random() * (maxSize - minSize) + minSize,
          alpha: 0.5,
          decay: Math.random() * 0.015 + 0.01
        };
      });
    },
    trigger() {
      this.generateExplosion();
    }
  }
};